import React, { PropsWithChildren, useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { ExternalUrlDragItemType } from 'app/area/external-url-groups/form/constants';
import { ExternalUrlItem } from 'app/area/external-url-groups/form/types-store';
import styles from './external-url-drag.scss';

interface ExternalUrlDragProps {
  item: ExternalUrlItem;
  type: ExternalUrlDragItemType;
  canDrag: boolean;
}

export const ExternalUrlDrag = ({
  item, type, canDrag, children
}: PropsWithChildren<ExternalUrlDragProps>) => {

  const [, dragRef, preview] = useDrag({
    canDrag,
    type,
    item,
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  return <div ref={(node) => {
    dragRef(node);
  }} className={canDrag ? styles.dragable : undefined}>
    {children}
  </div>;
};
